import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

const motesSlack: string = 'https://hooks.slack.com/services/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';

@Injectable()
export class SlackService {

    constructor(private http: HttpClient) { }

    private headers: HttpHeaders = new HttpHeaders({
        'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
    });

    private options: { headers: HttpHeaders } = ({ headers: this.headers })

    public post(message: string) {
        let body = {
            'text': message
        }
        //let bodyString = JSON.stringify(body); // Stringify payload
        //let headers = new Headers({ 'Content-Type': 'application/json' }); // ... Set content type to JSON
        //let options = new RequestOptions({ headers: headers });

        this.http.post(motesSlack, body, this.options).subscribe((res) => {
            console.log(res);
        });
    }

}
